var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2061 9.57619H20.2652L22.8472 7.09619C21.8104 5.79265 20.4743 4.73664 18.9429 4.01045C17.4115 3.28426 15.7262 2.9075 14.0183 2.90953C7.88247 2.90953 2.91274 7.68286 2.91274 13.5762C2.91274 16.0162 3.75954 18.2429 5.18938 20.0429C6.88297 18.1762 10.0619 16.9095 14.0183 16.9095C17.9746 16.9095 21.1675 18.1762 22.8472 20.0429C24.3282 18.1876 25.1287 15.914 25.1238 13.5762H27.9002C27.9002 20.9095 21.6534 26.9095 14.0183 26.9095C6.38322 26.9095 0.136353 20.9095 0.136353 13.5762C0.136353 6.24286 6.38322 0.242859 14.0183 0.242859C18.3772 0.242859 22.278 2.17619 24.8184 5.20286L27.2061 2.90953V9.57619ZM14.0183 6.90953C16.3227 6.90953 18.1829 8.69619 18.1829 10.9095C18.1829 13.1229 16.3227 14.9095 14.0183 14.9095C11.7139 14.9095 9.85371 13.1229 9.85371 10.9095C9.85371 8.69619 11.7139 6.90953 14.0183 6.90953Z",
    fill: "#407DBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityHeader);
export default __webpack_public_path__ + "static/media/activity_header.c3fca76b103262b37551f0325f95f0b9.svg";
export { ForwardRef as ReactComponent };